import { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Fixed-height rounded container that frames a mini-preview inside the
 * onboarding sheet. Pointer events disabled so the preview never steals taps.
 */
export function ShowcaseFrame({
  children,
  height = 260,
  caption,
  captions,
  className,
}: {
  children: ReactNode;
  height?: number;
  caption?: string;
  /** Numbered caption list (used in extended mode). */
  captions?: string[];
  className?: string;
}) {
  return (
    <div className={cn("mt-3", className)}>
      <div
        className="relative rounded-2xl overflow-hidden border border-[var(--roava-border)] bg-[var(--roava-bg-elev)]"
        style={{ height }}
        aria-hidden="true"
      >
        <div className="absolute inset-0 pointer-events-none select-none">
          {children}
        </div>
        {/* Soft edge fade so it reads as a preview */}
        <div className="absolute inset-x-0 top-0 h-6 bg-gradient-to-b from-[var(--roava-bg-elev)] to-transparent pointer-events-none" />
        <div className="absolute inset-x-0 bottom-0 h-8 bg-gradient-to-t from-[var(--roava-bg-elev)] to-transparent pointer-events-none" />
      </div>
      {captions && captions.length > 0 ? (
        <ol className="mt-3 space-y-1.5 text-[13px] leading-snug text-[var(--roava-text-muted)]">
          {captions.map((c, i) => (
            <li key={i} className="flex gap-2">
              <span className="shrink-0 size-5 rounded-full bg-[var(--roava-blue)]/10 text-[var(--roava-blue)] text-[11px] font-semibold grid place-items-center">
                {i + 1}
              </span>
              <span>{c}</span>
            </li>
          ))}
        </ol>
      ) : caption ? (
        <p className="mt-2 text-[12px] text-center text-[var(--roava-text-muted)] leading-snug">
          {caption}
        </p>
      ) : null}
    </div>
  );
}
